import { render, staticRenderFns } from "./account.vue?vue&type=template&id=247683cc&scoped=true"
import script from "./account.vue?vue&type=script&lang=ts"
export * from "./account.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247683cc",
  null
  
)

export default component.exports